/* eslint-disable */
const hexToRgb = (hex: string): [number, number, number] => {
    const clean = hex.replace('#', '');
    const bigint = parseInt(clean, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};

const rgbToHex = (r: number, g: number, b: number): string =>
    '#' + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, '0')).join('');

const interpolateColor = (
    c1: [number, number, number],
    c2: [number, number, number],
    t: number,
): [number, number, number] => c1.map((v, i) => v + (c2[i] - v) * t) as [number, number, number];

const generateInterpolatedColors = (colorStops: string[], totalSteps: number): string[] => {
    const positions = colorStops.map((_, i) => i / (colorStops.length - 1));
    const result: string[] = [];

    for (let i = 0; i < totalSteps; i++) {
        const t = i / (totalSteps - 1); // global position 0–1

        // Find which two color stops t is between
        let index = positions.findIndex((pos, j) => t >= pos && t <= positions[j + 1]);

        if (index === -1) index = positions.length - 2;

        const localT = (t - positions[index]) / (positions[index + 1] - positions[index] || 1);

        const c1 = hexToRgb(colorStops[index]);
        const c2 = hexToRgb(colorStops[index + 1]);
        const rgb = interpolateColor(c1, c2, localT);

        result.push(rgbToHex(...rgb));
    }

    return Array.isArray(result) ? [...new Set(result)] : [];
};

export { generateInterpolatedColors };
